'use client';
import { config } from '@/apollo/config';
import { BANNER_LIST_QUERY } from '@/apollo/graphql/queries/bannerQueries/bannerQueries';
import { Link, useRouter } from '@/i18n/navigation';
import { useQuery } from '@apollo/client';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Button } from 'rsuite';
import styles from './trade-in.module.scss';
type Props = {};

const TradeIn = () => {
  const { data: bannerData, loading } = useQuery(BANNER_LIST_QUERY, {
    variables: { first: 1, filter: { bannerType: 'MAIN_MD' } },
  });

  const [imageUrl, setImageUrl] = useState('');
  const [imageWidth, setImageWidth] = useState(1400);
  const [imageHeight, setImageHeight] = useState(300);
  const [buttonStyles, setButtonStyles] = useState({
    bottom: '21%',
    left: '5%',
  });
  const router = useRouter();

  useEffect(() => {
    const handleResize = () => {
      if (!bannerData?.banners?.edges || bannerData.banners.edges.length === 0)
        return;

      const screenWidth = window.innerWidth;
      let newImageUrl = `${config.publicApiUrl}${bannerData.banners.edges[0].node.image}`;
      let newImageWidth = 1400;
      let newImageHeight = 300;
      let newButtonStyles = { bottom: '21%', left: '5%' };

      if (screenWidth < 500 && bannerData.banners.edges[0].node.imageSm) {
        newImageUrl = `${config.publicApiUrl}${bannerData.banners.edges[0].node.imageSm}`;
        newImageWidth = 343;
        newImageHeight = 194;
        newButtonStyles = { bottom: '6%', left: '5%' };
      } else if (
        screenWidth >= 500 &&
        screenWidth < 1024 &&
        bannerData.banners.edges[0].node.imageMd
      ) {
        newImageUrl = `${config.publicApiUrl}${bannerData.banners.edges[0].node.imageMd}`;
        newImageWidth = 736;
        newImageHeight = 300;
        newButtonStyles = { bottom: '8%', left: '4%' };
      }

      setImageUrl(newImageUrl);
      setImageWidth(newImageWidth);
      setImageHeight(newImageHeight);
      setButtonStyles(newButtonStyles);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [bannerData]);

  return (
    <div className={styles.tradeinWrapper}>
      {bannerData?.banners?.edges[0]?.node.showButton && (
        <Button
          type="button"
          onClick={() =>
            router.push(bannerData?.banners?.edges[0]?.node?.url || '#')
          }
          className={styles.changeBtn}
          style={{
            backgroundColor:
              bannerData?.banners?.edges[0]?.node?.buttonColor || '#FBBF24',
            ...buttonStyles,
          }}
        >
          {bannerData?.banners?.edges[0]?.node?.buttonText}
        </Button>
      )}
      {loading ? (
        <div className={styles.skeleton}>
          <Skeleton />
        </div>
      ) : (
        bannerData?.banners?.edges?.length > 0 &&
        imageUrl && (
          <>
            {!bannerData?.banners?.edges[0]?.node.showButton ? (
              <Link
                href={bannerData?.banners?.edges[0]?.node?.url || '#'}
                passHref
              >
                <Image
                  className={styles.tradeImage}
                  width={imageWidth}
                  height={imageHeight}
                  layout="responsive"
                  src={imageUrl}
                  alt={'trade-in-image'}
                />
              </Link>
            ) : (
              <Image
                className={styles.tradeImage}
                width={imageWidth}
                height={imageHeight}
                layout="responsive"
                src={imageUrl}
                alt={'trade-in-image'}
              />
            )}
          </>
        )
      )}
    </div>
  );
};

export default TradeIn;
